<template lang="pug">
  v-dialog(v-model="show"  max-width="1000px"  persistent)
    ControlImportTransactionDialog(
      v-if="showControlImportTransactionDialog"
      :importedTransactionData="importedTransactionData"
      @resolve="resolveDialog"
      @close="closeControlImportTransactionDialog")
    input(type="file" accept=".xml" ref="fileInput" @change="onFileChange")
    v-card.d-flex.flex-column(v-if="!showControlImportTransactionDialog" flat )
      v-card-title {{ $t('bankTransactionPage.importTransaction') }}
      v-card-text
        v-container.pa-0.align-content-center
          v-row.justify-center.mb-5
            v-btn.pb-0(@click="uploadTransactionFile" color="primary") {{ $t('bankTransactionPage.uploadTransaction') }}
          v-row.justify-center.mb-5
            span.file(v-if="isValidFileType") {{fileName}}
            span.file(v-else) {{ $t('bankTransactionPage.invalidFile') }}
      v-divider
      v-card-actions
        v-spacer
        v-btn.ma-0(color="primary" text @click="onCloseImportDialog")  {{ $t('addBoarderDialog.closeButtonLabel') }}
        v-btn(color="primary" :disabled="!xmlString" :loading="saveInProgress" @click="onSubmitButtonClick") {{ $t('bankTransactionPage.nextTransaction') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop,} from 'vue-property-decorator'
import {Action} from "vuex-class";
import { UPLOAD_TRANSACTION} from "@/store/action-types";
import ControlImportTransactionDialog from "@/components/user/ControlImportTransactionDialog.vue";
import BankTransactionImport from "@/model/BankTransactionImport";
import BankTransaction from "@/model/BankTransaction/BankTransaction";

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

@Component({
  components: {
    ControlImportTransactionDialog,
  },
})
export default class ImportTransactionDialog extends Vue {
  $refs!: {
    fileInput: Vue & {
      click(): string
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Action(UPLOAD_TRANSACTION) uploadTransaction!: { (payload: string): Promise<BankTransactionImport> }
  private showControlImportTransactionDialog: boolean = false
  private importedTransactionData: BankTransactionImport | null = null
  private saveInProgress: boolean = false
  private xmlString: string | null = null
  private fileName: string = ''
  private importedTransactions: number[] = []
  private isValidFileType: boolean = true

  onCloseImportDialog () {
    this.$emit('close', this.importedTransactions)
  }
  closeControlImportTransactionDialog () {
    this.onCloseImportDialog()
  }

  resolveDialog () {
    this.$emit('resolve', this.importedTransactionData)
  }

  onSubmitButtonClick () {
    if (this.xmlString) {
      this.uploadFile(this.xmlString)
    }
  }

  uploadTransactionFile () {
    this.$refs.fileInput.click()
  }

  onFileChange (e: EventFile): void {
    if (e && e.target.files) {
      const file: File | undefined = e.target.files[0]
      const fileType: string[] | null = file.name.split('.')
      if(file && fileType && fileType[fileType.length -1] === 'xml') {

        this.isValidFileType = true
        this.fileName = file.name

        file.text().then((item: string) => {
          const xml = new DOMParser().parseFromString(item, 'text/xml');
          const serializer = new XMLSerializer()
          this.xmlString = serializer.serializeToString(xml)
        })
      } else {
        this.isValidFileType = false
      }
    }
  }

  async uploadFile (file: string): Promise<void> {
    this.saveInProgress = true
    try{
      this.importedTransactionData = await this.uploadTransaction(file)
      this.showControlImportTransactionDialog = true
      this.importedTransactionData.transactions.forEach((item: BankTransaction) => {
        this.importedTransactions.push(item.transaction.id)
      })
    } catch (e) {

    } finally {
      this.saveInProgress = false
    }
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>
input[type="file"]
  display none

.file
  font-size 20px
</style>
